import { LayerSpecification, Map } from "mapbox-gl";
import { useEffect } from "react";

import { useGaiaMap } from "../../hooks/useGaiaMap";

type Props = {
    layers: LayerSpecification[];
};

function addLayers(map: Map, layers: LayerSpecification[]) {
    layers.forEach(layer => {
        if (!map.getLayer(layer.id)) map.addLayer(layer);
    });
}

export default function GaiaMapStyle({ layers }: Props) {
    const { map } = useGaiaMap();

    useEffect(() => {
        if (!map) return;
        addLayers(map, layers);

        return () => {
            if (!map || !map.getStyle()) return;
            layers.forEach(layer => {
                if (map.getLayer(layer.id)) map.removeLayer(layer.id);
            });
        };
    }, [map, layers]);

    useEffect(() => {
        function onStyleLoad() {
            if (!map) return;
            addLayers(map, layers);
        }
        map?.on("style.load", onStyleLoad);
        return () => {
            map?.off("style.load", onStyleLoad);
        };
    }, [map, layers]);

    return null;
}
